import { ReducerBuilder } from 'reducers/ReducerBuilder';
import { payloadReducer } from 'reducers/reducerUtils';
import * as IngredientList from 'types/_general/Store/IngredientList';

const rb = new ReducerBuilder<IngredientList.Type>();

export const createIngredientListLoadedAction = rb.createActionForReducer<IngredientList.Type>(
	payloadReducer((x) => x),
	'IngredientList/LoadedFromBackend'
);

export const ingredientListReducer = rb.createReducer();
